export const CreatePointMultiplierSchemas = {
  rulesCriteriaJsonSchema: {
    type: 'object',
    properties: {
      rulesCriteria: {
        type: 'string'
      }
    }
  },
  segmentJsonSchema: {
    type: 'object',
    properties: {
      segment: {
        type: 'string'
      }
    }
  },
  categoryJsonSchema: {
    type: 'object',
    properties: {
      category: {
        type: 'string'
      }
    }
  },
  channelJsonSchema: {
    type: 'object',
    properties: {
      channel: {
        type: 'string'
      }
    }
  },
  rulesCriteriaUISchema: {
    type: 'HorizontalLayout',
    className: '',
    elements: [
      {
        type: 'HorizontalLayout',
        elements: [
          {
            type: 'Control',
            scope: '#/properties/rulesCriteria',
            component: 'dropdownControl',
            label: 'Rules Criteria*',
            placeholder: 'Select',
            className: 'text-sm box-size-width',
            isDark: true,
            isClearable: false
          },
          {
            type: 'Control',
            scope: '#/properties/segment',
            component: 'dropdownControl',
            label: 'Segment*',
            placeholder: 'Select',
            className: 'text-sm box-size-width',
            isDark: true,
            isClearable: false
          }
        ]
      }
    ]
  }
};
